import RemoveUserPartnerCodeForm from './RemoveUserPartnerCodeForm';

export default RemoveUserPartnerCodeForm;
